import { store } from "../index"

export const getDomainId = () => {
  const { event } = store.getState()
  return event.domainId
}

export const getEventId = () => {
  const { event } = store.getState()
  return event.id
}
